import React, { useMemo } from 'react';

import { DocumentController } from '@/components/Shared/ui';
import { useAppSelector } from '@/store';

import { FILE_NAMES } from '../../constants';
import { GrnFactoryCheck } from '../../entities';
import useInstructionsText from '../../hooks/useInstructionsText';

const ShinhanBank: React.FC = () => {
  const { attachedFiles } = useAppSelector((state) => state.financingStep);

  useInstructionsText();

  const files = useMemo(
    () =>
      attachedFiles?.filter(
        (file) =>
          file.type === 'guaranteeShinhan' ||
          file.type === 'spouse_consent' ||
          file.type === 'tech_passport'
      ) || [],
    [attachedFiles]
  );

  return (
    <div className="financing-step__form">
      {files.length > 0 ? (
        files.map((file) => (
          <React.Fragment key={file.type}>
            <DocumentController
              fileLink={file.uuid}
              title={FILE_NAMES[file.type as keyof typeof FILE_NAMES]}
              downloadable
            />
            {file.type === 'guaranteeShinhan' && (
              <GrnFactoryCheck
                grnFileLink={file.link}
                grnFileType={file.type}
              />
            )}
          </React.Fragment>
        ))
      ) : (
        <p className="financing-step__no-documents">Нет документов</p>
      )}
    </div>
  );
};

export default ShinhanBank;
